
define('jsx!components/modal/share/share-code',[
	"underscore",
	"jquery",
	"react",
	"jsx!components/widgets/toggle",
], function(_, $, React, Toggle) {
	var ____Class3=React.Component;for(var ____Class3____Key in ____Class3){if(____Class3.hasOwnProperty(____Class3____Key)){ShareCode[____Class3____Key]=____Class3[____Class3____Key];}}var ____SuperProtoOf____Class3=____Class3===null?null:____Class3.prototype;ShareCode.prototype=Object.create(____SuperProtoOf____Class3);ShareCode.prototype.constructor=ShareCode;ShareCode.__superConstructor__=____Class3;
		function ShareCode(props) {"use strict";
			____Class3.call(this,props);

			_.bindAll(this,
				"selectLinkInput",
				"toggleEmbedOptions",
				"copyLink",
				"copyEmbedCode",
				"updateSizeOption",
				"updateSize",
				"adaptMinSize",
				"toggleLoop",
				"toggleSlidePanel",
				"renderSizeButton",
				"renderEmbedOptions",
				"renderLink",
				"renderEmbedLink"
			);

			this.defaultSizes = {
				small: { width: 448, height: 252 },
				medium: { width: 896, height: 504 },
				large: { width: 1920, height: 1080 }
			};

			this.state = {
				width: this.defaultSizes.medium.width,
				height: this.defaultSizes.medium.height,
				sizeType: "custom",
				showEmbedOptions: false,
				loop: false,
				slidePanel: false,
			};
		}

		Object.defineProperty(ShareCode.prototype,"selectLinkInput",{writable:true,configurable:true,value:function(e) {"use strict";
			if(!this.props.actions.getUserAgent().isMobile()) {
				$(e.target).select();
			}
		}});

		Object.defineProperty(ShareCode.prototype,"toggleEmbedOptions",{writable:true,configurable:true,value:function() {"use strict";
			this.setState({ showEmbedOptions: !this.state.showEmbedOptions });
		}});

		Object.defineProperty(ShareCode.prototype,"copyLink",{writable:true,configurable:true,value:function() {"use strict";
			React.findDOMNode(this.refs.link).select();
			document.execCommand("copy");
			this.props.actions.toast(".buncee-modal-action", "Copied");
		}});

		Object.defineProperty(ShareCode.prototype,"copyEmbedCode",{writable:true,configurable:true,value:function() {"use strict";
			React.findDOMNode(this.refs.embedCode).select();
			document.execCommand("copy");
			this.props.actions.toast(".buncee-modal-action", "Copied");
		}});

		Object.defineProperty(ShareCode.prototype,"updateSizeOption",{writable:true,configurable:true,value:function(type) {"use strict";
			var newState = {};

			if(type != "custom") {
				newState = this.defaultSizes[type];
			}
			newState.sizeType = type;

			this.setState(newState);
		}});

		Object.defineProperty(ShareCode.prototype,"updateSize",{writable:true,configurable:true,value:function(e) {"use strict";
			if(isNaN(e.target.value)) {
				return;
			}

			var name = e.target.name;
			var width, height;

			// 16 : 9
			if(name == "width") {
				width = e.target.value;
				height = parseInt(e.target.value * 9 / 16);
			}
			else {
				width = parseInt(e.target.value * 16 / 9);
				height = e.target.value;
			}

			this.setState({ width: width, height: height });
		}});

		Object.defineProperty(ShareCode.prototype,"adaptMinSize",{writable:true,configurable:true,value:function() {"use strict";
			var width = this.state.width;
			var height = this.state.height;
			var minWidth = 448, minHeight = 252;
			var maxWidth = 1920, maxHeight = 1080;

			if(width < minWidth || height < minHeight) {
				this.setState({ width: minWidth, height: minHeight });
			}
			else if(width > maxWidth || height > maxHeight) {
				this.setState({ width: maxWidth, height: maxHeight });
			}
		}});

		Object.defineProperty(ShareCode.prototype,"toggleLoop",{writable:true,configurable:true,value:function() {"use strict";
			this.setState({ loop: !this.state.loop });
		}});

		Object.defineProperty(ShareCode.prototype,"toggleSlidePanel",{writable:true,configurable:true,value:function() {"use strict";
			this.setState({ slidePanel: !this.state.slidePanel });
		}});

		Object.defineProperty(ShareCode.prototype,"renderSizeButton",{writable:true,configurable:true,value:function(sizeType) {"use strict";
			return React.createElement("button", {type: "button", 
				className: 
					this.state.sizeType == sizeType ?
					"embed-option-button active" :
					"embed-option-button", 
				
				onClick: this.updateSizeOption.bind(this, sizeType)
			}, 
				sizeType
			);
		}});

		Object.defineProperty(ShareCode.prototype,"renderEmbedOptions",{writable:true,configurable:true,value:function() {"use strict";
			if(!this.state.showEmbedOptions) {
				return null;
			}

			var buncee = window.appData.buncee;

			return React.createElement("div", {className: "embed-options form-horizontal"}, 
				React.createElement("div", {className: "embed-preview"}, 
					React.createElement("iframe", {src: buncee.links.embed.split('?')[0] +
						'?render_slide_panel=' + (this.state.slidePanel ? '1' : '0') +
						'&loop=' + (this.state.loop ? '1' : '0'), 
						allowFullScreen: true})
				), 
				React.createElement("div", {className: "embed-option form-group"}, 
					React.createElement("label", {className: "col-sm-3 control-label"}, "Size"), 
					React.createElement("div", {className: "col-sm-9 embed-option-buttons"}, 
						 this.renderSizeButton("small"), 
						 this.renderSizeButton("medium"), 
						 this.renderSizeButton("large"), 
						 this.renderSizeButton("custom") 
					), 
					React.createElement("div", {className: "col-sm-9 col-sm-offset-3 embed-option-inputs"}, 
						React.createElement("input", {className: "embed-option-input form-control", value: this.state.width, name: "width", onChange: this.updateSize, onBlur: this.adaptMinSize, readOnly: this.state.sizeType != "custom"}), 
						React.createElement("span", {style: { margin: "0 5px"}}, "x"), 
						React.createElement("input", {className: "embed-option-input form-control", value: this.state.height, name: "height", onChange: this.updateSize, onBlur: this.adaptMinSize, readOnly: this.state.sizeType != "custom"}), 
						React.createElement("span", {style: { margin: "0 5px"}}, "pixels"), 
						React.createElement("span", {className: "embed-option-recommend button-type-b"}, 
							"Recommendations?", 
							React.createElement("div", {className: "embed-option-recommend-box"}, 
								React.createElement("div", null, "Kidblog - 700x393"), 
								React.createElement("div", null, "Wordpress - 896x504")
							)
						)
					)
				), 
				React.createElement("div", {className: "embed-option form-group"}, 
					React.createElement("label", {className: "col-sm-3 control-label"}, "Loop"), 
					React.createElement(Toggle, {
						classes: "embed-option-inputs col-sm-9", 
						toggleStatus: this.toggleLoop, 
						status: this.state.loop}
					)
				), 
				React.createElement("div", {className: "embed-option form-group"}, 
					React.createElement("label", {className: "col-sm-3 control-label"}, "Slide Panel"), 
					React.createElement(Toggle, {
						classes: "embed-option-inputs col-sm-9", 
						toggleStatus: this.toggleSlidePanel, 
						status: this.state.slidePanel}
					)
				)
			);
		}});

		Object.defineProperty(ShareCode.prototype,"renderLink",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee;

			if(this.props.actions.getUserAgent().isMobile()) {
				return React.createElement("input", {className: "form-control", type: "text", value: buncee.links.view, readOnly: true, onClick: this.selectLinkInput, ref: "link"});
			}

			return React.createElement("div", {className: "input-group"}, 
				React.createElement("input", {className: "form-control", type: "text", value: buncee.links.view, readOnly: true, onClick: this.selectLinkInput, ref: "link"}), 
					React.createElement("span", {className: "input-group-btn"}, 
						React.createElement("button", {className: "btn btn-default", onClick: this.copyLink}, "COPY")
					)
			);
		}});

		Object.defineProperty(ShareCode.prototype,"renderEmbedLink",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee;
			var embedCode = '<iframe src="' + 
						buncee.links.embed.split('?')[0] + 
						'?render_slide_panel=' + (this.state.slidePanel ? '1' : '0') +
						'&loop=' + (this.state.loop ? '1' : '0') +
						'" width="' + this.state.width + 
						'" height="' + this.state.height + 
						'" allowFullScreen></iframe>';

			if(this.props.actions.getUserAgent().isMobile()) {
				return React.createElement("input", {id: "embed-code", className: "form-control", type: "text", value: embedCode, readOnly: true, onClick: this.selectLinkInput, ref: "embedCode"});
			}

			return React.createElement("div", {className: "input-group"}, 
				React.createElement("input", {id: "embed-code", className: "form-control", type: "text", value: embedCode, readOnly: true, onClick: this.selectLinkInput, ref: "embedCode"}), 
				React.createElement("span", {className: "input-group-btn"}, 
					React.createElement("button", {className: "btn btn-default", onClick: this.copyEmbedCode}, "COPY")
				)
			);
		}});

		Object.defineProperty(ShareCode.prototype,"render",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			if(buncee.privacy_level == "private") {
				return this.props.renderPrivacyLevelWarning("Only Me");
			} else if(buncee.privacy_level == "domain") {
				return this.props.renderPrivacyLevelWarning("Anyone part of " + window.appData.client.name);
			}

			return React.createElement("div", {className: "modal-tab-area share-code", style: { marginTop: "0"}}, 
				React.createElement("div", {className: "form-group"}, 
					React.createElement("label", null, "Link"), 
					this.renderLink()
				), 
				React.createElement("div", {className: "form-group"}, 
					React.createElement("label", null, "Embed Code"), 
					React.createElement("span", {className: "label-option", onClick: this.toggleEmbedOptions}, 
						
							this.state.showEmbedOptions ?
							React.createElement("span", {className: "icons8-minus-math"}, " Hide Options") :
							React.createElement("span", {className: "icons8-plus-math"}, " Show Options")
						
					), 
					this.renderEmbedLink()
				), 
				React.createElement("div", {className: "form-group"}, 
					this.renderEmbedOptions()
				)
			)
		}});
	

	return ShareCode;
});
